export default [
  {
    path: '/spklu/okupansi-spklu',
    name: 'spklu-okupansi-spklu',
    component: () => import('../../views/spklu/okupansi_spklu.vue'),
    meta: {
      title: 'SPKLU',
      activeMenu: 'SPKLU',
      breadcrumb: [
        {
          text: 'SPKLU',
          disabled: true
        },
        {
          text: 'Utilisasi SPKLU',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/spklu/proyeksi-spklu',
    name: 'spklu-proyeksi-spklu',
    component: () => import('../../views/spklu/proyeksi_spklu.vue'),
    meta: {
      title: 'SPKLU',
      activeMenu: 'SPKLU',
      breadcrumb: [
        {
          text: 'SPKLU',
          disabled: true
        },
        {
          text: 'Perencanaan SPKLU',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/spklu/monitoring-spklu',
    name: 'spklu-availability-spklu',
    component: () => import('../../views/spklu/availability_spklu'),
    meta: {
      title: 'Availability SPKLU',
      activeMenu: 'SPKLU',
      breadcrumb: [
        {
          text: 'Availability SPKLU',
          disabled: true
        },
        {
          text: 'Status SPKLU',
          disabled: true
        }
      ]
    }
  },

  {
    path: '/spklu/dil-spklu',
    name: 'dil-spklu-spklu',
    component: () => import('../../views/spklu/dil_spklu'),
    meta: {
      title: 'DIL SPKLU',
      activeMenu: 'SPKLU',
      breadcrumb: [
        {
          text: 'SPKLU',
          disabled: true
        },
        {
          text: 'DIL SPKLU',
          disabled: true
        }
      ]
    }
  }

]
